import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/api/services';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-dashboard-side-menu',
    templateUrl: './dashboard-side-menu.component.html',
    styleUrls: ['./dashboard-side-menu.component.css'],
    standalone: false
})
export class DashboardSideMenuComponent {
  constructor(private route: ActivatedRoute, private authService: AuthService) {}

  showImportSubMenu: boolean = false;
  showExportSubMenu: boolean = false;

  isAllowedAdminUser: boolean = false;

  ngOnInit() {
    this.showImportSubMenu = this.isAnyImportSubmenuActive();
    this.showExportSubMenu = this.isAnyExportSubmenuActive();

    this.isAllowedAdminUser = this.checkIfAllowedAdmin();
  }

  toggleImportSubMenu() {
    this.showImportSubMenu = !this.showImportSubMenu;
  }

  toggleExportSubMenu() {
    this.showExportSubMenu = !this.showExportSubMenu;
  }

  isActive(route: string): boolean {
    return this.route.snapshot.routeConfig?.path === route;
  }

  isActiveSubmenu(route: string): boolean {   
    return this.route.snapshot.url.some(segment => segment.path.includes(route));
  }

  isAnyImportSubmenuActive(): boolean {
    return this.route.snapshot.url.some(segment =>
      ['products', 'media', 'stock', 'clients', 'registos'].includes(segment.path)
    );
  }

  isAnyExportSubmenuActive(): boolean {
    return this.route.snapshot.url.some(segment =>
      ['encomendas'].includes(segment.path)
    );
  }

  private checkIfAllowedAdmin(): boolean {
    const token = localStorage.getItem('BIO2_AccessToken');
    if (!token) return false;

    const decodedToken = this.authService.getDecodedAccessToken(token);
    const role = decodedToken?.role;
    const registoId = decodedToken?.registoId;

    return role === 'Administrador' && environment.allowedAdminIds.includes(registoId);
  }

}
